// extracted by mini-css-extract-plugin
export default {"nav":"Nav__nav___pjA3q","navHover":"Nav__navHover___TFJD5"};